/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/ProductLink.js
 */

import React from 'react';
import { Link } from 'react-router-dom';

const getLink = (data) =>
  !data.featureDetailId
    ? `/search?query=featureDetail:${data.id}`
    : `/search?query=featureDetail:${data.featureDetailId}`;

const ProductLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <Link className="Link" to={getLink(data)}>
          <div className="Type">
            {!data.featureDetailId ? 'Feature Detail' : 'Feature'}
          </div>
          <div className="Value">
            {!data.featureDetailId ? data.id : data.feature.name}
          </div>
        </Link>
      </div>
      <div className="SummaryLink">
        <Link className="Link" to={getLink(data)}>
          {getLink(data)}
        </Link>
      </div>
      <div className="SummaryData">
        <div>
          <p>
            Feature Detail Id:{' '}
            {!data.featureDetailId ? data.id : data.featureDetailId}
          </p>
          <p>Cpq Id: {data.cpqId}</p>
          <p>Feature Id: {data.feature.id}</p>
          <p>Feature Name: {data.feature.name}</p>
        </div>
      </div>
    </div>
  );
};

export default ProductLink;
